import { AccordionSecondary } from '@snack-uikit/accordion';
import React, { useEffect, useState } from 'react';
import { AvailableFilters } from 'src/types/marketplace';

import { AccordionHead } from '../AccordionHead';
import { FilterBlock } from '../FilterBlock';
import s from './DesktopFilters.module.scss';

type Props = {
  availableFilters: AvailableFilters;
};

export function DesktopFilters({ availableFilters }: Props) {
  const [expanded, setExpanded] = useState<string[]>([]);

  useEffect(() => {
    setExpanded(availableFilters.map(({ filterKey }) => filterKey));
  }, [availableFilters]);

  const handleToggleExpanded = (filterKeys: string[]) =>
    setExpanded(filterKeys);

  return (
    <div className={s.filterBody}>
      <AccordionSecondary
        className={s.accordion}
        selectionMode="multiple"
        expanded={expanded}
        onExpandedChange={handleToggleExpanded}
      >
        {availableFilters.map((filter) => (
          <AccordionHead
            key={filter.filterKey}
            filterKey={filter.filterKey}
            titleKey={filter.titleKey}
          >
            <FilterBlock {...filter} />
          </AccordionHead>
        ))}
      </AccordionSecondary>
    </div>
  );
}
